<template>
    <RightSidebar v-if="!appData.isMobile">
        <div class="col-12" v-if="type == Enums.RIGHT_TYPE.DASHBOARD && data">
            <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
            <PreviewCard css="text-purple-blue" icon="icon-bullseye" title="Hedefim" :value="data.myGoal" />
            <PreviewCard css="text-science" icon="icon-meeting" title="Randevularım">
                <div v-if="data.appointmentList.length > 0" class="inner-bg d-flex flex-column gap-3 py-3 px-3">
                    <div v-for="r in data.appointmentList" :key="r">
                        <span class="name text-white d-block b-600 fs-5">{{r.name}}</span>
                        <span class="meeting-date d-block">
                            <span class="date text-white fs-6">{{D.DateToString(r.dayDate)}} {{getDay(r.dayDate)}}</span>
                            <span class="time text-white fs-6"> - {{D.TimeToString(r.dayDate)}}</span>
                        </span>
                    </div>
                </div>
                <div v-else>-</div>
            </PreviewCard>

            <PreviewCard css="text-primary" icon="icon-pen-to-square" title="Verimlilik Ortalaması">
                <div class="pt-3">
                    <ProgressBar v-model="data.averageEfficiencyScore" :type="3" />
                </div>
            </PreviewCard>
        </div>

        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.WEEKLY && data">
            <div class="weekly-analytics-sidebar">
                <div class="weekly-panel-card summary-card">
                    <div class="weekly-card-title">
                        <svg data-v-e566d5b2="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-e566d5b2="" d="M10.0001 13.3333V17.5M13.3334 12.1992V17.5M16.6667 8.88V17.5M18.3334 2.5L11.1284 9.705C11.0897 9.7438 11.0437 9.77459 10.9931 9.79559C10.9425 9.8166 10.8882 9.82741 10.8334 9.82741C10.7786 9.82741 10.7243 9.8166 10.6737 9.79559C10.6231 9.77459 10.5771 9.7438 10.5384 9.705L7.79508 6.96167C7.71694 6.88355 7.61098 6.83967 7.5005 6.83967C7.39001 6.83967 7.28405 6.88355 7.20591 6.96167L1.66675 12.5M3.33341 15.3858V17.5M6.66675 12.2133V17.5" stroke="#3478F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span>Haftalık Özet</span>
                    </div>

                    <div class="summary-grid">
                        <div class="summary-box purple">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path d="M13 23.8333V13M13 13L3.56417 7.58333M13 13L22.4358 7.58333M8.125 4.62583L17.875 10.205M11.9167 23.5408C12.246 23.731 12.6197 23.8311 13 23.8311C13.3803 23.8311 13.754 23.731 14.0833 23.5408L21.6667 19.2075C21.9957 19.0175 22.269 18.7444 22.4592 18.4154C22.6493 18.0865 22.7496 17.7133 22.75 17.3333V8.66667C22.7496 8.28671 22.6493 7.91354 22.4592 7.58459C22.269 7.25564 21.9957 6.98248 21.6667 6.7925L14.0833 2.45917C13.754 2.269 13.3803 2.16889 13 2.16889C12.6197 2.16889 12.246 2.269 11.9167 2.45917L4.33333 6.7925C4.00428 6.98248 3.73098 7.25564 3.54083 7.58459C3.35069 7.91354 3.25039 8.28671 3.25 8.66667V17.3333C3.25039 17.7133 3.35069 18.0865 3.54083 18.4154C3.73098 18.7444 4.00428 19.0175 4.33333 19.2075L11.9167 23.5408Z" stroke="#8E42D8" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Ders</span>
                            <strong>{{ data.subjectCount }}</strong>
                        </div>

                        <div class="summary-box blue">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path d="M17.3333 4.33333H19.4999C20.0746 4.33333 20.6257 4.56161 21.032 4.96793C21.4383 5.37426 21.6666 5.92536 21.6666 6.5V21.6667C21.6666 22.2413 21.4383 22.7924 21.032 23.1987C20.6257 23.6051 20.0746 23.8333 19.4999 23.8333H6.49992C5.92528 23.8333 5.37418 23.6051 4.96785 23.1987C4.56153 22.7924 4.33325 22.2413 4.33325 21.6667V6.5C4.33325 5.92536 4.56153 5.37426 4.96785 4.96793C5.37418 4.56161 5.92528 4.33333 6.49992 4.33333H8.66659M9.74992 15.1667L11.9166 17.3333L16.2499 13M9.74992 2.16667H16.2499C16.8482 2.16667 17.3333 2.65169 17.3333 3.25V5.41667C17.3333 6.01497 16.8482 6.5 16.2499 6.5H9.74992C9.15161 6.5 8.66658 6.01497 8.66658 5.41667V3.25C8.66658 2.65169 9.15161 2.16667 9.74992 2.16667Z" stroke="#2F86E9" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Konu</span>
                            <strong>{{ data.taskCount }}</strong>
                        </div>

                        <div class="summary-box green">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path d="M22.75 5.41667H3.25M7.58333 13H3.25M7.58333 20.5833H3.25M13 19.5C13.6821 20.4095 14.6331 21.0813 15.7183 21.4203C16.8034 21.7593 17.9677 21.7482 19.0462 21.3887C20.1248 21.0292 21.0628 20.3395 21.7276 19.4172C22.3923 18.4949 22.75 17.3869 22.75 16.25C22.75 14.9571 22.2364 13.7171 21.3221 12.8029C20.4079 11.8886 19.1679 11.375 17.875 11.375C16.4342 11.375 15.1233 11.96 14.1808 12.9025L11.9167 15.1667M16.25 15.1667H11.9167V10.8333" stroke="#29AE73" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>KBS</span>
                            <strong>{{ data.kbsCount }}</strong>
                        </div>

                        <div class="summary-box orange">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path d="M13.0001 23.8333C18.9832 23.8333 23.8334 18.9831 23.8334 13C23.8334 7.01692 18.9832 2.16667 13.0001 2.16667C7.017 2.16667 2.16675 7.01692 2.16675 13C2.16675 18.9831 7.017 23.8333 13.0001 23.8333Z" stroke="#FF8A19" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.0001 19.5C16.5899 19.5 19.5001 16.5899 19.5001 13C19.5001 9.41015 16.5899 6.5 13.0001 6.5C9.41023 6.5 6.50008 9.41015 6.50008 13C6.50008 16.5899 9.41023 19.5 13.0001 19.5Z" stroke="#FF8A19" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.0001 15.1667C14.1967 15.1667 15.1667 14.1966 15.1667 13C15.1667 11.8034 14.1967 10.8333 13.0001 10.8333C11.8035 10.8333 10.8334 11.8034 10.8334 13C10.8334 14.1966 11.8035 15.1667 13.0001 15.1667Z" stroke="#FF8A19" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Planlanan Gün</span>
                            <strong>{{ data.plannedDayCount }}/7</strong>
                        </div>
                    </div>
                </div>

                <div class="weekly-panel-card weekly-work-time-card">
                    <button type="button" class="work-add-btn" @click="ui.openWorkModal()">+</button>

                    <div class="weekly-card-title">
                        <svg data-v-e566d5b2="" width="16" height="16" viewBox="0 0 20 20" fill="none"><path data-v-e566d5b2="" d="M10 5V10L13.3333 11.6667M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="#7B28D8" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span>Haftalık Çalışılan Süre</span>
                    </div>

                    <div class="weekly-card-head">
                        <div>
                            <div class="weekly-value-group">
                                <strong class="weekly-big-value">{{ appData.fn.getHour(weeklyWorkTotalMinute) }}</strong>
                                <span class="weekly-target-value">/ {{ appData.fn.getHour(data.workMaxCount) }}</span>
                            </div>
                            <small>Saat</small>
                        </div>
                        <div class="weekly-change" :class="{ positive: C.Int(data.workCountChange)>= 0, negative: C.Int(data.workCountChange) < 0 }">
                            {{ C.Int(data.workCountChange) >= 0 ? '▲' : '▼' }}
                            %{{ Math.abs(Math.round(C.Int(data.workCountChange))) }}
                            <span>geçen haftaya göre</span>
                        </div>
                    </div>
                    <div class="weekly-work-chart-wrap">
                        <div class="weekly-hour-axis">
                            <span>{{ appData.fn.getHour(weeklyWorkMaxValue) }}</span>
                            <span>{{ appData.fn.getHour(C.Int(weeklyWorkMaxValue / 2)) }}</span>
                            <span>0</span>
                        </div>
                        <div class="weekly-bar-chart purple-chart">
                            <span
                                v-for="r in weeklyWorkDays"
                                :key="r.dayName"
                                :style="{ height: Math.max(18, C.Int((C.Int(r.value) / weeklyWorkMaxValue) * 100)) + '%' }"
                            ></span>
        </div>
                </div>

                    <div class="weekly-days with-axis">
                        <span v-for="r in weeklyWorkDays" :key="r.dayName">
                            {{ r.dayName }}
                    </span>
                </div>
                </div>

                <div class="weekly-panel-card">
                    <div class="weekly-card-title question">
                        <svg data-v-e566d5b2="" width="16" height="16" viewBox="0 0 20 20" fill="none"><path data-v-e566d5b2="" d="M13.3333 3.33333H15C15.4419 3.33333 15.8659 3.50893 16.1785 3.82149C16.4911 4.13405 16.6667 4.55797 16.6667 5V6.66667M6.66667 18.3333H5C4.558 18.3333 4.13405 18.1577 3.82149 17.8452C3.50893 17.5326 3.33333 17.1087 3.33333 16.6667V5C3.33333 4.55797 3.50893 4.13405 3.82149 3.82149C4.13405 3.50893 4.558 3.33333 5 3.33333H6.66667M17.7892 13.0525C17.9535 12.8882 18.0839 12.6931 18.1728 12.4784C18.2617 12.2636 18.3075 12.0334 18.3075 11.8008C18.3075 11.5683 18.2617 11.3381 18.1728 11.1233C18.0839 10.9086 17.9535 10.7135 17.7892 10.5492C17.6248 10.3849 17.4297 10.2545 17.215 10.1656C17.0002 10.0767 16.77 10.0309 16.5375 10.0309C16.3049 10.0309 16.0747 10.0767 15.86 10.1656C15.6452 10.2545 15.4501 10.3849 15.2858 10.5492L11.1117 14.725C10.9136 14.9229 10.7686 15.1677 10.69 15.4367L9.9928 17.8271C9.9719 17.8988 9.97064 17.9748 9.98918 18.0472C10.0077 18.1195 10.0454 18.1855 10.0982 18.2384C10.151 18.2912 10.2171 18.3289 10.2894 18.3474C10.3618 18.3659 10.4378 18.3647 10.5095 18.3438L12.8999 17.6465C13.1689 17.568 13.4136 17.423 13.6117 17.225L17.7892 13.0525ZM7.5 1.66667H12.5C12.9602 1.66667 13.3333 2.03976 13.3333 2.5V4.16667C13.3333 4.6269 12.9602 5 12.5 5H7.5C7.03976 5 6.66667 4.6269 6.66667 4.16667V2.5C6.66667 2.03976 7.03976 1.66667 7.5 1.66667Z" stroke="#FF7B0A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        <span>Haftalık Çözülen Soru</span>
                    </div>

                    <div class="weekly-card-head">
                        <div>
                            <div class="weekly-value-group">
                                <strong class="weekly-big-value">{{ data.questionCount }}</strong>
                                <span class="weekly-target-value">/ {{ data.questionMaxCount }}</span>
                            </div>

                            <small>Soru</small>
                        </div>

                         <div class="weekly-change" :class="{ positive: C.Int(data.questionCountChange) >= 0, negative: C.Int(data.questionCountChange) < 0 }">
                                {{ C.Int(data.questionCountChange) >= 0 ? '▲' : '▼' }}
                                %{{ Math.abs(Math.round(C.Int(data.questionCountChange))) }}

                                <span>geçen haftaya göre</span>
                        </div>
                    </div>

                    <div class="question-donut-area">
                        <div class="question-donut" :style="weeklyQuestionDonutStyle">
                            <div>
                                <strong>{{ data.questionCount }}</strong>
                                <span>Toplam</span>
                                </div>
                        </div>

                        <div class="question-legend">
                            <div>
                                <span class="dot green"></span>
                                Doğru
                                <b>{{ weeklyQuestionSummary.correct }}</b>
                </div>

                            <div>
                                <span class="dot orange"></span>
                                Yanlış
                                <b>{{ weeklyQuestionSummary.wrong }}</b>
                </div>

                            <div>
                                <span class="dot gray"></span>
                                Boş
                                <b>{{ weeklyQuestionSummary.empty }}</b>
                    </div>
                </div>
                </div>
        </div>
                </div>
        </div>

        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.DAILY && data">
            <template v-if="data">
                <div class="daily-analytics-sidebar">

                    <div class="daily-panel-card daily-teacher-card d-none">
                        <div class="daily-card-title teacher">
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <path d="M16.6667 15.8333V14.1667C16.6667 13.2826 16.3155 12.4348 15.6904 11.8096C15.0652 11.1845 14.2174 10.8333 13.3333 10.8333H6.66667C5.78261 10.8333 4.93477 11.1845 4.30964 11.8096C3.68452 12.4348 3.33333 13.2826 3.33333 14.1667V15.8333M13.3333 4.16667C13.3333 6.00762 11.8409 7.5 10 7.5C8.15905 7.5 6.66667 6.00762 6.66667 4.16667C6.66667 2.32572 8.15905 0.833333 10 0.833333C11.8409 0.833333 13.3333 2.32572 13.3333 4.16667Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Danışmanım</span>
                        </div>

                        <div class="daily-teacher-info">
                            <img src="@/assets/img/avatar-consultant-default.png" alt="Danışman" />
                            <div>
                                <strong>{{ data.teacherFullName }}</strong>
                                <small v-if="data.teacherTitle">{{ data.teacherTitle }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="daily-panel-card daily-work-card" v-if="data.hasWeek">
                        <div class="daily-card-title work">
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <path d="M10 5V10L13.3333 11.6667M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Günlük Çalışılan Süre</span>
                        </div>

                        <div class="daily-work-summary">
                            <strong>{{ appData.fn.getHour(data.workCount) }}</strong>
                            <b>%{{ dailyWorkPercent }}</b>
                        </div>

                        <div class="daily-target-row daily-work-target">
                            <span>Günlük hedef <strong>{{ appData.fn.getHour(data.workMaxCount / 7) }}</strong></span>
                        </div>

                        <div class="daily-progress-track">
                            <i :style="{ width: dailyWorkPercent + '%' }"></i>
                        </div>

                        <div v-if="data.isTodayWeek" class="daily-time-control">
                            <button type="button" @click="changeDailyWork(-15)">−</button>
                            <div>
                                <strong>{{ appData.fn.getHour(data.workCount) }}</strong>
                                <span>çalışma süresi</span>
                            </div>
                            <button type="button" @click="changeDailyWork(15)">+</button>
                        </div>

                        <div v-if="data.isTodayWeek" class="daily-time-shortcuts">
                            <button type="button" @click="setDailyWork(120)">2s</button>
                            <button type="button" @click="setDailyWork(240)">4s</button>
                            <button type="button" @click="setDailyWork(360)">6s</button>
                            <button type="button" @click="setDailyWork(480)">8s</button>
                            <button type="button" @click="setDailyWork(600)">10s</button>
                        </div>
                    </div>

                    <div class="daily-panel-card daily-question-card">
                        <div class="daily-card-title question">
                            <svg data-v-e566d5b2="" width="16" height="16" viewBox="0 0 20 20" fill="none"><path data-v-e566d5b2="" d="M13.3333 3.33333H15C15.4419 3.33333 15.8659 3.50893 16.1785 3.82149C16.4911 4.13405 16.6667 4.55797 16.6667 5V6.66667M6.66667 18.3333H5C4.558 18.3333 4.13405 18.1577 3.82149 17.8452C3.50893 17.5326 3.33333 17.1087 3.33333 16.6667V5C3.33333 4.55797 3.50893 4.13405 3.82149 3.82149C4.13405 3.50893 4.558 3.33333 5 3.33333H6.66667M17.7892 13.0525C17.9535 12.8882 18.0839 12.6931 18.1728 12.4784C18.2617 12.2636 18.3075 12.0334 18.3075 11.8008C18.3075 11.5683 18.2617 11.3381 18.1728 11.1233C18.0839 10.9086 17.9535 10.7135 17.7892 10.5492C17.6248 10.3849 17.4297 10.2545 17.215 10.1656C17.0002 10.0767 16.77 10.0309 16.5375 10.0309C16.3049 10.0309 16.0747 10.0767 15.86 10.1656C15.6452 10.2545 15.4501 10.3849 15.2858 10.5492L11.1117 14.725C10.9136 14.9229 10.7686 15.1677 10.69 15.4367L9.9928 17.8271C9.9719 17.8988 9.97064 17.9748 9.98918 18.0472C10.0077 18.1195 10.0454 18.1855 10.0982 18.2384C10.151 18.2912 10.2171 18.3289 10.2894 18.3474C10.3618 18.3659 10.4378 18.3647 10.5095 18.3438L12.8999 17.6465C13.1689 17.568 13.4136 17.423 13.6117 17.225L17.7892 13.0525ZM7.5 1.66667H12.5C12.9602 1.66667 13.3333 2.03976 13.3333 2.5V4.16667C13.3333 4.6269 12.9602 5 12.5 5H7.5C7.03976 5 6.66667 4.6269 6.66667 4.16667V2.5C6.66667 2.03976 7.03976 1.66667 7.5 1.66667Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                            <span>Günlük Çözülen Soru</span>
                        </div>

                        <div class="daily-question-body">
                            <div class="daily-question-donut" :style="dailyQuestionDonutStyle">
                                <div>
                                    <strong>{{ data.questionCount }}</strong>
                                    <span>Soru</span>
                                </div>
                            </div>

                            <div class="daily-question-legend">
                                <div>
                                    <span class="dot green"></span>
                                    Doğru
                                    <b>{{ dailyQuestionSummary.correct }}</b>
                                </div>
                                <div>
                                    <span class="dot orange"></span>
                                    Yanlış
                                    <b>{{ dailyQuestionSummary.wrong }}</b>
                                </div>
                                <div>
                                    <span class="dot gray"></span>
                                    Boş
                                    <b>{{ dailyQuestionSummary.empty }}</b>
                                </div>
                            </div>
                        </div>

                        <div class="daily-target-row daily-question-target">
                            <span>Günlük hedef <strong>{{ (C.Int(data.questionMaxCount) / 7).toFixed(0) }} soru</strong></span>
                            <b>%{{ dailyQuestionPercent }}</b>
                        </div>

                        <div class="daily-progress-track blue">
                            <i :style="{ width: dailyQuestionPercent + '%' }"></i>
                        </div>
                    </div>

                    <div class="daily-panel-card daily-progress-card">
                        <div class="daily-card-title progress">
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <path d="M17.5 5.83333L11.25 12.0833L7.91667 8.75L2.5 14.1667M17.5 5.83333H12.5M17.5 5.83333V10.8333" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Günlük İlerleme</span>
                        </div>

                        <div class="daily-target-row mt-3">
                            <span>Günlük program ilerlemen</span>
                            <b>%{{ C.Int(data.progress) }}</b>
                        </div>

                        <div class="daily-progress-track cyan">
                            <i :style="{ width: C.Int(data.progress) + '%' }"></i>
                        </div>
                    </div>

                    </div>
            </template>
        </div>

        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.LESSON && data">
            <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.HOW_STUDY})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start">
                <i class="icon icon-study-chalkboard text-dark-blue me-2 fs-3"></i>
                <span class="fs-3 text-dark-blue b-600">Nasıl Çalışılır?</span>
            </a>
            <PreviewCard css="text-rose" icon="icon-chalkboard-user" title="Ders Hocası">
                <div class="d-flex flex-column">
                    <span class="name b-500 text-default fs-4" v-for="r in data.lessonTeacherList" :key="r">
                        <!--<button v-if="r.channel.length > 0" class="rs-action-btn" @click.stop="modal.linkPreview.open(r.channel)" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Kanalı buradan görebilirsiniz.">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99996 13C10.4294 13.5741 10.9773 14.0492 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3617 15.0436 15.0795 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4507 9.59699 21.9547 8.33398 21.9433 7.023C21.9319 5.71201 21.4061 4.45795 20.479 3.53091C19.552 2.60387 18.2979 2.07803 16.987 2.06663C15.676 2.05524 14.413 2.55921 13.47 3.47L11.75 5.18M14 11C13.5705 10.4259 13.0226 9.95082 12.3934 9.60706C11.7642 9.26331 11.0684 9.05889 10.3533 9.00767C9.63816 8.95645 8.92037 9.05964 8.24861 9.31022C7.57685 9.56081 6.96684 9.95293 6.45996 10.46L3.45996 13.46C2.54917 14.403 2.04519 15.666 2.05659 16.977C2.06798 18.288 2.59382 19.5421 3.52086 20.4691C4.4479 21.3961 5.70197 21.922 7.01295 21.9334C8.32393 21.9448 9.58694 21.4408 10.53 20.53L12.24 18.82" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>-->
                        {{ r.fullName }}
                    </span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Kaynaklarım">
                <div class="inner-bg d-flex flex-column p-3 mb-2" v-if="data.resourceList.length > 0">
                    <span class="course-resources d-block">
                        <template v-for="(r, index) in data.resourceList" :key="r">
                            <template v-if="r.isStudent">
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6 ">{{ r.name }}</span>
                            </template>
                            <template v-else>
                                <hr v-if="index > 0 && data.resourceList[index - 1].isStudent" />
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6 ">{{ r.name }}</span>
                            </template>
                        </template>
                    </span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.RESOURCE})" class="btn btn-light radius-sm d-flex align-items-center justify-content-center text-science">
                        <i class="icon icon-plus text-science me-2 fs-3"></i>
                        <span class="fs-5 text-science b-600">Kaynak Ekle</span>
                    </a>
                </div>
            </PreviewCard>
        </div>

        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.ANALYSIS && data">
            <template v-if="data.tyt || data.ayt">
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="TYT Net Ortalama" v-if="data.tyt">
                    <NetAverage />
                </PreviewCard>
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="AYT Net Ortalama" v-else-if="data.ayt">
                    <NetAverage />
                </PreviewCard>
            </template>
        </div>
    </RightSidebar>

    <RightSidebarMobile css="btn-open-right" v-else>
        <!--<div class="col-12" v-if="type == Enums.RIGHT_TYPE.DASHBOARD && data">
            <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
            <PreviewCard css="text-purple-blue" icon="icon-bullseye" title="Hedefim" :value="data.myGoal" />
            <PreviewCard css="text-science" icon="icon-meeting" title="Randevularım">
                <div v-if="data.appointmentList.length > 0" class="inner-bg d-flex flex-column gap-3 py-3 px-3">
                    <div v-for="r in data.appointmentList" :key="r">
                        <span class="name text-white d-block b-600 fs-5">{{r.name}}</span>
                        <span class="meeting-date d-block">
                            <span class="date text-white fs-6">{{D.DateToString(r.dayDate)}} {{getDay(r.dayDate)}}</span>
                            <span class="time text-white fs-6"> - {{D.TimeToString(r.dayDate)}}</span>
                        </span>
                        <template v-if="r.meetingState == Enums.MEETING_STATE.PENDING && D.DateTimeMinEqual(C.Date(r.dayDate), D.DateAdd(Enums.DATE.MINUTE, 5, D.ServerNow()))">
                            <button v-if="r.meetingServer == Enums.MEETING_SERVER.AGORA" @click="meetingStatus.set()" class="btn btn-turkish btn-xs fs-6 text-nowrap" style="width:135px;">
                                <i class="icon icon-meeting text-white fs-5 me-1"></i>
                                <span>Görüşmeye Katıl</span>
                            </button>
                            <a v-else-if="!Text.IsEmpty(r.meetingLink)" :href="r.meetingLink" target="_blank" class="btn btn-turkish btn-xs fs-6 text-nowrap" style="width:135px;">
                                <i class="icon icon-meeting text-white fs-5 me-1"></i>
                                <span>Görüşmeye Katıl</span>
                            </a>
                        </template>
                        <button v-else-if="r.meetingState == Enums.MEETING_STATE.DONE && C.Str(r.meetingStudentOpinion) == ''" @click="selected({ type: Enums.RIGHT_SELECTED.MEETING_MOOD, data: r })" class="btn btn-turkish btn-xs fs-6" style="width:135px;">Görüşmeyi Oyla</button>
                        <span v-else class="text-white fs-6 fst-italic">
                            <span class="badge text-white bg-turkish fs-6 text-wrap w-100" v-if="(r.meetingState == Enums.MEETING_STATE.NONE || r.meetingState == Enums.MEETING_STATE.PENDING) && D.DateTimeMinEqual(D.ServerNow(), C.Date(r.dayDate))">
                                {{ D.CountDownToTime(C.Date(r.dayDate)) }} sonra
                            </span>
                            <template v-else>
                                <span>{{ J.FindKey(Constants.Meeting.State, r.meetingState) }}</span>
                                <img v-if="C.Str(r.meetingStudentOpinion) != ''" class="ms-1" style="width:16px;height:16px;" :src="J.FindKey(Constants.Mood.List, C.Int(r.meetingStudentOpinion), 'img')" />
                            </template>
                        </span>
                    </div>
                </div>
                <div v-else>-</div>
            </PreviewCard>
            <PreviewCard css="text-primary" icon="icon-pen-to-square" title="Verimlilik Ortalaması">
                <div class="pt-3">
                    <ProgressBar v-model="data.averageEfficiencyScore" :type="3" />
                </div>
            </PreviewCard>
        </div>-->
        <!--<div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.WEEKLY && data">
            <WeeklyWorkingTimeChart class="mb-3" v-model="data.workCount" :max="data.workMaxCount" />
            <PreviewCard css="text-purple-blue" icon="icon-pen" title="Haftalık Çözülen Soru" :value="data.questionCount + ' Soru'" />
            <PreviewCard css="text-math" icon="icon-route" title="Haftalık İlerleme">
                <div class="pt-3">
                    <ProgressBar class="blue" v-model="data.progress" :type="2" />
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.DAILY && data">
            <template v-if="data.isWeek">
                <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
                <PreviewCard v-if="data.isTodayWeek" css="text-rose" icon="icon-clock" title="Çalışılan Süre">
                    <NumericUpDown class="p-0 mb-3" :max="1200" v-model="data.workCount" :step="15" :isText="true" :textType="2" @update:modelValue="dailyWorkTime();" />
                    <div class="d-flex gap-3 w-100 px-1">
                        <button class="btn btn-sm btn-inverse inverse-primary m-0 flex-grow-1" @click="data.workCount = (120 * r);dailyWorkTime();" v-for="r in 4">
                            <span>{{r * 2}}</span>
                        </button>
                    </div>
                </PreviewCard>
                <PreviewCard v-else css="text-rose" icon="icon-clock" title="Günlük Çalışılan Süre" :value="appData.fn.getHour(data.workCount) + ' Saat'" />
                <PreviewCard css="text-purple-blue" icon="icon-pen" title="Günlük Çözülen Soru" :value="data.questionCount + ' Soru'" />
                <PreviewCard css="text-math" icon="icon-route" title="Günlük İlerleme">
                    <div class="pt-3">
                        <ProgressBar class="blue" v-model="data.progress" :type="2" />
                    </div>
                </PreviewCard>
            </template>
            <template v-else>
                <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
            </template>
        </div>-->
        <div class="col-12" v-if="type == Enums.RIGHT_TYPE.LESSON && data">
            <PreviewCard css="text-yellow" icon="icon-chalkboard-user" title="Danışmanım" :value="data.teacherFullName" />
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.HOW_STUDY})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start p-3">
                <i class="icon icon-study-chalkboard text-dark-blue me-2 fs-3"></i>
                <span class="fs-3 text-dark-blue b-600">Nasıl Çalışılır?</span>
            </a>
            <PreviewCard css="text-rose" icon="icon-chalkboard-user" title="Ders Hocası">
                <div class="d-flex flex-column">
                    <span class="name b-500 text-default fs-4" v-for="r in data.lessonTeacherList" :key="r">
                        <!--<button v-if="r.channel.length > 0" class="rs-action-btn" @click.stop="modal.linkPreview.open(r.channel)" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Kanalı buradan görebilirsiniz.">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99996 13C10.4294 13.5741 10.9773 14.0492 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3617 15.0436 15.0795 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4507 9.59699 21.9547 8.33398 21.9433 7.023C21.9319 5.71201 21.4061 4.45795 20.479 3.53091C19.552 2.60387 18.2979 2.07803 16.987 2.06663C15.676 2.05524 14.413 2.55921 13.47 3.47L11.75 5.18M14 11C13.5705 10.4259 13.0226 9.95082 12.3934 9.60706C11.7642 9.26331 11.0684 9.05889 10.3533 9.00767C9.63816 8.95645 8.92037 9.05964 8.24861 9.31022C7.57685 9.56081 6.96684 9.95293 6.45996 10.46L3.45996 13.46C2.54917 14.403 2.04519 15.666 2.05659 16.977C2.06798 18.288 2.59382 19.5421 3.52086 20.4691C4.4479 21.3961 5.70197 21.922 7.01295 21.9334C8.32393 21.9448 9.58694 21.4408 10.53 20.53L12.24 18.82" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>-->
                        {{ r.fullName }}
                    </span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Kaynaklarım">
                <div class="inner-bg d-flex flex-column p-3 mb-2" v-if="data.resourceList.length > 0">
                    <span class="course-resources d-block">
                        <template v-for="(r, index) in data.resourceList" :key="r">
                            <template v-if="r.isStudent">
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                            <template v-else>
                                <hr v-if="index > 0 && data.resourceList[index - 1].isStudent" />
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                        </template>
                    </span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.RESOURCE})" class="btn btn-light radius-sm d-flex align-items-center justify-content-center text-science">
                        <i class="icon icon-plus text-science me-2 fs-3"></i>
                        <span class="fs-5 text-science b-600">Kaynak Ekle</span>
                    </a>
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.ANALYSIS && data">
            <template v-if="data.tyt || data.ayt">
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="TYT Net Ortalama" v-if="data.tyt">
                    <NetAverage></NetAverage>
                </PreviewCard>
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="AYT Net Ortalama" v-else-if="data.ayt">
                    <NetAverage></NetAverage>
                </PreviewCard>
            </template>
            <template v-else>
                <!--<PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <template v-else-if="data.speedTest">
                <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
            </template>-->
            </template>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.TEST && data">
            <!--<PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
            <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                <span class="course-resources pb-2 d-block">
                    <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                    <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                    <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                </span>
            </div>
        </PreviewCard>
        <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
            <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                <span class="course-resources pb-2 d-block">
                    <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                    <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                    <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                </span>
            </div>
        </PreviewCard>
        <template v-else-if="data.speedTest">
            <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
            <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
            <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
        </template>-->
        </div>
    </RightSidebarMobile>
   
    <WorkTimeModal
        v-model="ui.workModalOpen"
        :date="ui.workDayDate"
        :minute="ui.workMinute"
        :day-minute-list="data?.dayWorkCount ?? []"
        @save="ui.saveWorkTime"
        :week-start-date="data?.startDate"
        :week-end-date="data?.endDate"
    />
    <LinkPreview ref="modalLinkPreview" />
</template>

<script>
    import { reactive, toRefs, computed, nextTick } from "vue";

    import { Constants } from "@/helpers/constants";
    import { Enums } from "@/helpers/enums";
    import { appData, C, D, J } from "@/helpers/global";
    import { Web, Msg } from "@/helpers/web";

    import RightSidebar from "@/layouts/_partials/RightSidebar.vue";
    import RightSidebarMobile from "@/layouts/_partials/RightSidebar.mobile.vue";

    import ProgressBar from "@/components/ProgressBar.vue";
    import WorkTimeModal from "@/components/modal/WorkTimeModal.vue";

    import PreviewCard from "@/components/card/PreviewCard.vue";
    import NetAverage from "@/components/card/NetAverage.vue";
    import WeeklyWorkingTimeChart from "@/components/chart/WeeklyWorkingTimeChart.vue";

    import { StudentWeeklyPlanService } from "@/services/api/student-weekly-plan";
    import { StudentWeeklyPlanChangeDayWorkCount } from "@/services/requests/student-weekly-plan_changeDayWorkCount";

    import LinkPreview from "@/components/modal/LinkPreview.vue";


    export default {
        components: {
            RightSidebar,
            RightSidebarMobile,
            ProgressBar,
            WorkTimeModal,
            PreviewCard,
            NetAverage,
            WeeklyWorkingTimeChart,
            LinkPreview,
        },

        setup() {
            const e = reactive({
                bus: appData.eventBus([
                    Constants.Key.RightSidebar,
                    Constants.Key.RightSidebarSelected,
                    Constants.Key.MeetingStatus
                ]),
                modalLinkPreview: null,
                modal: {
                    linkPreview: {
                        open(channel) {
                            e.modalLinkPreview.open({ list: [channel] });
                        },
                    },
                },
            ui: {
                workModalOpen: false,
                workDayDate: D.ServerNow(),
                workMinute: 60,

                openWorkModal() {
                    e.ui.workDayDate = e.data?.startDate ? C.Date(e.data.startDate) : D.ServerNow();
                    e.ui.workMinute = 0;
                    e.ui.workModalOpen = true;
                },

                closeWorkModal() {
                    e.ui.workModalOpen = false;
                },

                saveWorkTime(event) {
                    const sourceData = e.data;

                    if (!sourceData || C.Int(sourceData.id) <= 0) {
                        Msg.Warning("Hafta bilgisi bulunamadı!");
                        return;
                    }

                    const formatDate = (value) => {
                        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
                            return value.substring(0, 10);
                        }

                        const d = new Date(value);

                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, "0");
                        const day = String(d.getDate()).padStart(2, "0");

                        return `${year}-${month}-${day}`;
                    };

                    const dayWorkCount = (event.dayMinuteList ?? [])
                        .map(r => ({
                            day: formatDate(r.dayDate || r.day || r.date),
                            count: C.Int(r.minute || r.count || r.workMinute),
                        }))
                        .filter(r => r.day && r.day !== "NaN-NaN-NaN" && C.Int(r.count) > 0);

                    Web.Area((wait) => {
                        const j = new StudentWeeklyPlanChangeDayWorkCount({
                            id: sourceData.id,
                            dayWorkCount,
                        });

                        console.log("SIDEBAR WORK REQUEST MODEL =>", j);

                        StudentWeeklyPlanService.ChangeDayWorkCount(j, () => {
                            if (e.data) {
                                e.data.dayWorkCount = J.Clone(dayWorkCount);
                                e.data.workCount = dayWorkCount.reduce((total, r) => {
                                    return total + C.Int(r.count);
                                }, 0);
                            }

                            e.ui.workModalOpen = false;
                        }, wait);
                    }, appData.fn.main());
                }
            },

                meetingStatus: {
                set() {
                    e.bus.set(Constants.Key.MeetingStatus, true);
                }
                },

                type: computed(() => {
                    return C.Int(e.bus.get(Constants.Key.RightSidebar)?.type);
                }),

                data: computed(() => {
                    return e.bus.get(Constants.Key.RightSidebar)?.data;
                }),

            weeklyWorkDays: computed(() => {
                if (!e.data || !e.data.startDate) {
                    return [
                        { dayName: "Pzt", value: 0 },
                        { dayName: "Sal", value: 0 },
                        { dayName: "Çar", value: 0 },
                        { dayName: "Per", value: 0 },
                        { dayName: "Cum", value: 0 },
                        { dayName: "Cmt", value: 0 },
                        { dayName: "Paz", value: 0 },
                    ];
                }

                const list = e.data.dayWorkCount ?? [];

                return Array.from({ length: 7 }).map((_, index) => {
                    const dayDate = D.DateAdd(Enums.DATE.DAY, index, C.Date(e.data.startDate));
                    const item = list.find(r => D.DateEqual(r.day, dayDate));

                    return {
                        dayName: J.FindKey(Constants.Date.DaySortList, ((C.Date(dayDate).getDay() + 6) % 7 + 1)),
                        dayDate,
                        value: item ? C.Int(item.count) : 0
                    };
                });
            }),

            weeklyWorkTotalMinute: computed(() => {
                return e.weeklyWorkDays.reduce((total, r) => {
                    return total + C.Int(r.value);
                }, 0);
            }),

            weeklyWorkMaxValue: computed(() => {
                const values = e.weeklyWorkDays.map(r => C.Int(r.value));
                return Math.max(...values, 1);
            }),

            weeklyQuestionDays: computed(() => {
                if (!e.data || !e.data.startDate) {
                    return [
                        { dayName: "Pzt", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Sal", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Çar", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Per", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Cum", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Cmt", total: 0, correct: 0, wrong: 0, empty: 0 },
                        { dayName: "Paz", total: 0, correct: 0, wrong: 0, empty: 0 },
                    ];
                }

                const result = [];

                for (let i = 0; i < 7; i++) {
                    const dayDate = D.DateAdd(Enums.DATE.DAY, i, C.Date(e.data.startDate));

                    let total = 0;
                    let correct = 0;
                    let wrong = 0;
                    let empty = 0;

                    if (e.data.studentPlanList) {
                        e.data.studentPlanList.forEach((plan) => {
                            const list = Array.isArray(plan.dayQuestionCount)
                                ? plan.dayQuestionCount
                                : J.Parse(plan.dayQuestionCount, "[]");

                            const item = list.find(r => D.DateEqual(r.day, dayDate));

                            if (item) {
                                total += C.Int(item.count);
                                correct += C.Int(item.correct);
                                wrong += C.Int(item.wrong);
                                empty += C.Int(item.empty);
                            }
                        });
                    }

                    result.push({
                        dayName: J.FindKey(Constants.Date.DaySortList, ((C.Date(dayDate).getDay() + 6) % 7 + 1)),
                        dayDate,
                        total,
                        correct,
                        wrong,
                        empty,
                    });
                }

                return result;
            }),

            weeklyQuestionMaxValue: computed(() => {
                const values = e.weeklyQuestionDays.map(r => C.Int(r.total));
                return Math.max(...values, 1);
            }),

            weeklyQuestionSummary: computed(() => {
                return e.weeklyQuestionDays.reduce((total, r) => {
                    total.correct += C.Int(r.correct);
                    total.wrong += C.Int(r.wrong);
                    total.empty += C.Int(r.empty);
                    total.total += C.Int(r.total);

                    return total;
                }, {
                    total: 0,
                    correct: 0,
                    wrong: 0,
                    empty: 0,
                });
            }),

            weeklyQuestionDonutStyle: computed(() => {
                const correct = C.Int(e.weeklyQuestionSummary.correct);
                const wrong = C.Int(e.weeklyQuestionSummary.wrong);
                const empty = C.Int(e.weeklyQuestionSummary.empty);

                const detailTotal = correct + wrong + empty;

                if (detailTotal <= 0) {
                    return {
                        background: "conic-gradient(#E5E7EB 0 100%)"
                    };
                }

                const correctPercent = (correct / detailTotal) * 100;
                const wrongPercent = (wrong / detailTotal) * 100;
                const wrongEnd = correctPercent + wrongPercent;

                return {
                    background:
                        `conic-gradient(
                            #2CC879 0 ${correctPercent}%,
                            #FF970F ${correctPercent}% ${wrongEnd}%,
                            #CFD3DA ${wrongEnd}% 100%
                        )`
                };
            }),

                selected(args) {
                    e.bus.set(Constants.Key.RightSidebarSelected, args);
                },
            dailyWorkPercent: computed(() => {
                return Math.min(100, C.Int((C.Int(e.data?.workCount) / 360) * 100));
            }),

            dailyQuestionPercent: computed(() => {
                const target = C.Int(e.data?.questionTarget);
                if (target <= 0) { return 0; }

                return Math.min(100, C.Int((C.Int(e.data?.questionCount) / target) * 100));
            }),

            dailyQuestionSummary: computed(() => {
                const summary = e.data?.questionSummary || e.data?.dailyQuestionSummary;

                return {
                    correct: C.Int(summary?.correct),
                    wrong: C.Int(summary?.wrong),
                    empty: C.Int(summary?.empty),
                };
            }),

            dailyQuestionDonutStyle: computed(() => {
                const correct = C.Int(e.dailyQuestionSummary.correct);
                const wrong = C.Int(e.dailyQuestionSummary.wrong);
                const empty = C.Int(e.dailyQuestionSummary.empty);

                const total = correct + wrong + empty;

                if (total <= 0) {
                    return {
                        background: "conic-gradient(#E5EAF1 0 100%)"
                    };
                }

                const correctPercent = (correct / total) * 100;
                const wrongPercent = (wrong / total) * 100;
                const wrongEnd = correctPercent + wrongPercent;

                return {
                    background:
                        `conic-gradient(
                            #2CC879 0 ${correctPercent}%,
                            #FF970F ${correctPercent}% ${wrongEnd}%,
                            #CFD3DA ${wrongEnd}% 100%
                        )`
                };
            }),

            setDailyWork(minute) {
                e.data.workCount = C.Int(minute);
                e.dailyWorkTime();
            },

            changeDailyWork(step) {
                let value = C.Int(e.data.workCount) + C.Int(step);

                if (value < 0) {
                    value = 0;
                }

                if (value > 1200) {
                    value = 1200;
                }

                e.data.workCount = value;
                e.dailyWorkTime();
            },

                dailyWorkTime() {
                e.selected({
                    type: Enums.RIGHT_SELECTED.DAILY_WORK_TIME,
                    data: e.data.workCount
                });
                },

                getDay(day) {
                if (!day) {
                    return "-";
                }

                    return J.FindKey(Constants.Date.DayList, ((C.Date(day).getDay() + 6) % 7 + 1));
                },
            });

            return { ...toRefs(e) };
        },
    };
</script>

<style scoped>
.weekly-analytics-sidebar {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.weekly-card-title svg { 
    width: 16px;
    height: 16px;
}
.weekly-panel-card {
    position: relative;
    border-radius: 24px;
    background: #fff;
    border: 1px solid rgba(70, 45, 105, .08);
    box-shadow: 0 14px 34px rgba(58, 37, 88, .07);
    padding: 15px;
}

.weekly-card-title {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 14px;
    font-weight: 700;
    color: #24193e;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-top: 15px;
}

.summary-box {
    min-height: 100px;
    border-radius: 15px;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.summary-box span {
    font-size: 11px;
    font-weight: 500;
    color: #6f617d;
}

.summary-box strong {
    margin-top: 4px;
    font-size: 26px;
    line-height: 1;
    font-weight: 700;
}

.summary-box.purple {
    background: #f4eafd;
    color: #8e42d8;
}

.summary-box.blue {
    background: #eaf4ff;
    color: #2f86e9;
}

.summary-box.green {
    background: #eafaf3;
    color: #29ae73;
}

.summary-box.orange {
    background: #fff2e6;
    color: #ff8a19;
}

.weekly-card-head,
.weekly-progress-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.weekly-value-group {
    display: flex;
    align-items: baseline;
    flex-wrap: nowrap;
    gap: 4px;
    min-width: 0;
    margin-top: 10px;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.weekly-big-value {
    font-size: 22px;
    line-height: 1.1;
    font-weight: 700;
    color: #211735;
}

.weekly-target-value {
    font-size: 13px;
    line-height: 1.1;
    font-weight: 500;
    color: #9b95a6;
}

.weekly-panel-card small {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    font-weight: 700;
    color: #8d8298;
}

.weekly-change {
    margin-top: 12px;
    text-align: right;
    font-size: 12px;
    font-weight: 800;
}

.weekly-change span {
    display: block;
    margin-top: 5px;
    font-size: 11px;
    font-weight: 700;
    color: #8d8298;
}

.weekly-change.positive {
    color: #2bbf72;
}

.weekly-change.negative {
    color: #ff5b5b;
}

.work-add-btn {
    position: absolute;
    top: 13px;
    right: 13px;
    z-index: 2;
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 10px;
    background: #f4eafd;
    color: #8e42d8;
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
}

.weekly-bar-chart {
    height: 100px;
    margin-top: 0;
    display: flex;
    align-items: flex-end;
    gap: 10px;
}

.weekly-bar-chart span {
    flex: 1;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(180deg, #d9a6f2, #9a4cc8);
    transition: height .2s ease;
}

.weekly-days {
    margin-top: 5px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    font-size: 10px;
    font-weight: 800;
    color: #5d526b;
    text-align: center;
}

.question-donut-area {
    margin-top: 22px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.question-donut {
    width: 104px;
    height: 104px;
    border-radius: 50%;
    background: conic-gradient(#2cc879 0 65%, #ff970f 65% 84%, #cfd3da 84% 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.question-donut::before {
    content: "";
    position: absolute;
    width: 74px;
    height: 74px;
    border-radius: 50%;
    background: #fff;
}

.question-donut > div {
    position: relative;
    z-index: 1;
    text-align: center;
}

.question-donut strong {
    display: block;
    font-size: 18px;
    font-weight: 900;
    color: #23183d;
}

.question-donut span {
    font-size: 12px;
    font-weight: 800;
    color: #21a8ac;
}

.question-legend {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 13px;
}

.question-legend div {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 13px;
    font-weight: 800;
    color: #2b2240;
}

.question-legend b {
    margin-left: auto;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.dot.green {
    background: #2cc879;
}

.dot.orange {
    background: #ff970f;
}

.dot.gray {
    background: #cfd3da;
}

.progress-track-modern {
    margin-top: 15px;
    height: 20px;
    border-radius: 999px;
    background: #f0e7f6;
    overflow: hidden;
}

.progress-fill-modern {
    height: 100%;
    min-width: 48px;
    border-radius: inherit;
    background: linear-gradient(90deg, #b64dde, #8e42d8);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}

.progress-labels {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    font-weight: 600;
    color: #80728f;
}

.weekly-motivation-card {
    display: flex;
    align-items: center;
    gap: 14px;
    border-radius: 22px;
    padding: 15px;
    background: linear-gradient(135deg, #f5dfff, #f0e5ff);
    color: #2b2044;
}

.motivation-icon {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: #a94bd1;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
}

.motivation-content {
    width: calc(100% - 46px);
}

.weekly-motivation-card strong {
    display: block;
    font-size: 13px;
    font-weight: 700;
}

.weekly-motivation-card span {
    display: block;
    margin-top: 4px;
    font-size: 10px;
    font-weight: 500;
    color: #4d3e62;
}

.summary-box svg {
    margin-bottom: 4px;
    flex: 0 0 auto;
}

.weekly-work-chart-wrap {
    display: flex;
    align-items: stretch;
    gap: 5px;
    margin-top: 10px;
}

.weekly-hour-axis {
    width: 27px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 9px;
    font-weight: 600;
    color: #9a8aa8;
    text-align: right;
}

.weekly-work-chart-wrap .weekly-bar-chart {
    flex: 1;
}

.weekly-days.with-axis {
    padding-left: 32px;
}
.work-modal-calendar {
    overflow: hidden;
    border-radius: 18px;
}

.work-modal-calendar :deep(.week-calendar),
.work-modal-calendar :deep(.calendar),
.work-modal-calendar :deep(.week-list) {
    width: 100%;
    max-width: 100%;
}

.work-modal-calendar :deep(.week-calendar) {
    padding: 8px;
}

.work-modal-calendar :deep(.day-list),
.work-modal-calendar :deep(.days),
.work-modal-calendar :deep(.week-days) {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 4px;
}

.work-modal-calendar :deep(.day),
.work-modal-calendar :deep(.calendar-day),
.work-modal-calendar :deep(button) {
    min-width: 0;
    width: 100%;
    max-width: 100%;
}
.weekly-question-chart-wrap {
    display: flex;
    align-items: stretch;
    gap: 5px;
    margin-top: 10px;
}

.weekly-question-axis {
    width: 27px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 9px;
    font-weight: 600;
    color: #9a8aa8;
    text-align: right;
}

.question-chart {
    flex: 1;
}

.question-chart span {
    background: linear-gradient(180deg, #7C83FD, #5B63E6);
}
.daily-analytics-sidebar {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.daily-panel-card {
    position: relative;
    border-radius: 22px;
    background: #fff;
    border: 1px solid rgba(70, 45, 105, .08);
    box-shadow: 0 14px 34px rgba(58, 37, 88, .07);
    padding: 17px;
}

.daily-card-title {
    display: flex;
    align-items: center;
    gap: 9px;
    color: #24193e;
    font-size: 14px;
    font-weight: 700;
    background: transparent;
    height: auto;
}

.daily-card-title svg {
    width: 18px;
    height: 18px;
}

.daily-card-title.teacher svg { color: #f2a000; }
.daily-card-title.work svg { color: #a653cb; }
.daily-card-title.question svg { color: #6b73e8; }
.daily-card-title.progress svg { color: #42b8e9; }

.daily-teacher-info {
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.daily-teacher-info img {
    width: 45px;
    height: 45px;
    flex: 0 0 45px;
    border-radius: 50%;
    object-fit: cover;
    background: #f4eafd;
}

.daily-teacher-info strong {
    display: block;
    color: #20222b;
    font-size: 14px;
    font-weight: 600;
}

.daily-teacher-info small {
    display: block;
    margin-top: 3px;
    color: #8993a8;
    font-size: 11px;
    font-weight: 500;
}

/* Günlük hedefler: gerçekleşen değer ön planda, hedef bilgisi ikincil. */
.daily-work-summary {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    margin-top: 15px;
    min-width: 0;
}

.daily-work-summary strong {
    color: #211735;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
}

.daily-work-summary b {
    flex-shrink: 0;
    color: #8e42d8;
    font-size: 12px;
    font-weight: 600;
}

.daily-work-target {
    margin-top: 7px;
    margin-bottom: 3px;
}

.daily-progress-track {
    margin-top: 5px;
    height: 10px;
    border-radius: 999px;
    background: #e8edf4;
    overflow: hidden;
    width: 100%;
}

.daily-progress-track i {
    display: block;
    height: 100%;
    min-width: 0;
    border-radius: inherit;
    background: linear-gradient(90deg, #c987e6, #8e42d8);
}

.daily-progress-track.blue i {
    background: linear-gradient(90deg, #8b92ff, #5b63e6);
}

.daily-progress-track.cyan i {
    background: linear-gradient(90deg, #6ad0f2, #42b8e9);
}

.daily-time-control {
    margin-top: 16px;
    min-height: 48px;
    border-radius: 14px;
    background: #f8f3fc;
    display: grid;
    grid-template-columns: 38px 1fr 38px;
    align-items: center;
    gap: 8px;
    padding: 6px;
}

.daily-time-control button {
    width: 38px;
    height: 36px;
    border: 0;
    border-radius: 11px;
    background: #fff;
    color: #8e42d8;
    font-size: 21px;
    font-weight: 600;
    box-shadow: 0 8px 18px rgba(58, 37, 88, .08);
}

.daily-time-control div {
    text-align: center;
}

.daily-time-control strong {
    display: block;
    color: #211735;
    font-size: 14px;
    font-weight: 600;
}

.daily-time-control span {
    display: block;
    color: #8d8298;
    font-size: 10px;
    font-weight: 500;
}

.daily-time-shortcuts {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 7px;
}

.daily-time-shortcuts button {
    height: 30px;
    border: 0;
    border-radius: 8px;
    background: #f4eafd8c;
    color: #8e42d8;
    font-size: 12px;
    font-weight: 600;
}

.daily-question-body {
    margin-top: 18px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.daily-question-donut {
    width: 92px;
    height: 92px;
    flex: 0 0 92px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    position: relative;
}

.daily-question-donut::before {
    content: "";
    position: absolute;
    inset: 10px;
    border-radius: 50%;
    background: #fff;
}

.daily-question-donut > div {
    position: relative;
    z-index: 1;
    text-align: center;
}

.daily-question-donut strong {
    display: block;
    color: #211735;
    font-size: 18px;
    font-weight: 800;
    line-height: 1;
}

.daily-question-donut span {
    display: block;
    margin-top: 4px;
    color: #756b86;
    font-size: 10px;
    font-weight: 800;
}

.daily-question-legend {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.daily-question-legend div {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2b2240;
    font-size: 12px;
    font-weight: 600;
}

.daily-question-legend b {
    margin-left: auto;
}

.daily-target-row {
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.daily-target-row span {
    color: #756b86;
    font-size: 12px;
    font-weight: 600;
}

.daily-target-row b {
    color: #42b8e9;
    font-size: 13px;
    font-weight: 600;
}
.daily-question-target b{
    color:#6b73e8;
}

/* Hedef değerleri ana istatistiklerden daha hafif gösterilir. */
.daily-work-target span,
.daily-question-target span {
    color: #938ba3;
    font-size: 11px;
    font-weight: 400;
}

.daily-work-target span strong,
.daily-question-target span strong {
    color: #5d5963;
    font-size: 11px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
}


.dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
}

.dot.green { background: #2cc879; }
.dot.orange { background: #ff970f; }
.dot.gray { background: #cfd3da; }
</style>